import React, {FC, useState, useEffect} from "react";
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { StartPage } from "../../../components";
import { billingService } from "../../../api";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../../utils/display-price";
import { usePageTitle } from "../../../context/navigationContext";

const TaxRules:FC = () => {
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [paginationData, setPaginationData] = useState<any>()
  const [invoices, setInvoices] = useState<any[]>([])
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [t] = useTranslation()
  usePageTitle(t("PAGE_TITLE_TAX_RULES"));
  const getInvoices = () => {
    billingService.getTaxeRules({
      page:page || 1,
      page_size:pageSize || 10,
      ordering:ordering,
      search:searchString||''
    })
    .then((res) => {
      setInvoices(res.data.objects.map((taxRule:any) => {
        return {
          ...taxRule,
          name: taxRule.name || '-',
          level: taxRule.level?.toString() || '-',
          country: taxRule.country || '-',
          state: taxRule.state || '-',
          rate: taxRule.rate?.toString() || '-',
          start_date: taxRule.start_date ? timeConverterMMDDYYHHMM(taxRule.start_date) : '-',
          end_date: taxRule.end_date ? timeConverterMMDDYYHHMM(taxRule.end_date) : '-',
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      console.log('error', e);
      setPageLoading(false)
    })
  }
  useEffect(() => {
    getInvoices()
    const interval = setInterval(() => {
      getInvoices()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString])
  const ColumnsInvoices = [
    {
      title:t("NAME"),
      key:'name',
      sorted:true,
    },
    {
      title:t("LEVEL"),
      key:'level',
      sorted:true,
    },
    {
      title:t("COUNTRY"),
      key:'country',
      sorted:true,
    },
    {
      title:t("STATE"),
      key:'state',
      sorted:true,
    },
    {
      title:t("RATE"),
      key:'rate',
      sorted:true,
    },
    {
      title:t("START_DATE"),
      key:'start_date',
      sorted:true,
    },
    {
      title:t("END_DATE"),
      key:'end_date',
      sorted:true,
    },
  ]
  
  return (
    <>
      <StartPage
        title={`${t("TAX_RULES")}`}
        noResourceText={`${t("NO_TAX_RULES")}`}
        haveResource={invoices.length > 0}
        pageLoading={pageLoading}
        tableData={{
          columns:ColumnsInvoices,
          data:invoices,
          hideCheckbox:true,
          paginationData:paginationData,
          updateData:getInvoices
        }}
      />
    </>
  )
}

export default TaxRules
